import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

interface IBarragem {
    uuid: string;
    nome: string;
}
export interface IFileServices {
    file?: File | null,
    lista_dam: string[],
    titulo: string,
    data_emissao?: string,
    descricao?: string,
    tipo: any,
    classificacao?: string[],
    data_registro?: string,
    status?: boolean,
    uuid?: string,
    nome_arquivo?: string,
    npgb?: string
    barragens?: IBarragem[]
}

const create = async (data: IFileServices) => {
    await AuthService.verify();
    
    try {
        const token = await AuthService.getAccessToken();

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'data_emissao') {
                formData.append(key, value.replace(/"/g, '')); 
            } else if (key === 'file' && value instanceof File) {
                formData.append(key, value); 
            } else if (key === 'titulo' || key === 'descricao') {
                formData.append(key, value.replace(/"/g, ''));
            } else {
                formData.append(key, JSON.stringify(value)); 
            }
        });

        const response = await ApiBack.post('./files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });

        if (response.data) {
            return response;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};


const upgrade = async (uuid: string, data: IFileServices) => {
    await AuthService.verify();
    
    try {
        const token = await AuthService.getAccessToken();

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'data_emissao') {
                formData.append(key, value.replace(/"/g, '')); 
            } else if (key === 'file' && value instanceof File) {
                formData.append(key, value); 
            } else if (key === 'titulo' || key === 'descricao') {
                formData.append(key, value.replace(/"/g, ''));
            } else {
                formData.append(key, JSON.stringify(value)); 
            }
        });

        const response = await ApiBack.put(`./files?uuid=${uuid}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });

        if (response.data) {
            return response;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};

const deleteById = async(uuid: string): Promise<void | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        await ApiBack.delete(`/files?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}` 
            }
        },
            
        );
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro ao deletar registro.');
    }
};

const getById = async (uuid: string, download: string): Promise<any | Error> => {
    await AuthService.verify();
  
    try {
      const token = await AuthService.getAccessToken();

      if(download === 'False'){
          const response = await ApiBack.get(`/file?uuid=${uuid}&download=${download}`, {
            headers: {
              Authorization: `${token}`,
            },
          });

          if (response) {
            return response;
          }
      }else{
          const response = await ApiBack.get(`/file?uuid=${uuid}&download=${download}`, {
            headers: {
              Authorization: `${token}`,
            },
            responseType: 'blob',
          });

          if (response) {
            return response;
          }
      }

      return new Error('Erro ao buscar registros.');
    } catch (error) {
      console.error(error);
      return new Error(
        (error as { message: string }).message || 'Erro ao buscar registros.'
      );
    }
  };
  

const get = async(uuid: string): Promise<IFileServices[] | Error> => {
    try {

        const token = await AuthService.getAccessToken();

        const { data } = await ApiBack.get(`/files?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (data) {
            return data;
        }

        return new Error('Erro ao buscar registros.');

    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar registros.');
    }
};

const getFileType = async(): Promise<string[]|Error> => {
    try {

        const token = await AuthService.getAccessToken();

        const { data } = await ApiBack.get('/tipos', {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json; charset=utf-8'
            }
        });

        if (data) {
            return data;
        }

        return new Error('Erro ao buscar registros.');

    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar registros.');
    }
};

const listGlb = async(uuid: string): Promise<IFileServices[] | Error> => {
    try {

        const token = await AuthService.getAccessToken();

        const { data } = await ApiBack.get(`/listglb?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (data) {
            return data;
        }

        return new Error('Erro ao buscar registros.');

    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro ao buscar registros.');
    }
};

export const FileServicesBack = {
    create,
    upgrade,
    deleteById,
    getById,
    get,
    getFileType,
		listGlb
};